import ListDocs from "../documents/ListDocs";
import { useTranslation } from "react-i18next";

const Docs = () => {
  const { t } = useTranslation();
  return (
    <div className="h-full flex flex-col">
      <div className="bg-white rounded-lg shadow-lg border border-gray-200 w-full h-full overflow-hidden flex flex-col">
        {/* En-tête des documents - Optimisé pour PC portable */}
        <div className="bg-thead px-4 py-3">
          <div className="flex items-center gap-2">
            <div className="bg-white/50 backdrop-blur-sm rounded-lg p-1.5">
              <svg className="w-4 h-4 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
              </svg>
            </div>
            <h3 className="text-black font-semibold text-base font-Nunito">
              {t("Documents")}
            </h3>
          </div>
        </div>

        {/* Zone de documents scrollable - Compact */}
        <div className="flex-1 overflow-y-auto p-3 bg-gray-50">
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 h-full overflow-hidden">
            <ListDocs />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Docs;